import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from './containers/StatefulHoc';
import {
  rootPath,
} from './utils/paths';
import { AbilityContext } from '../../components/AbilityContext';
import appPermissions from '../../util/appPermissions';

const Pim = () => {
  const abilityContext = useContext(AbilityContext);

  return (
    <Switch>
      {abilityContext.can(
        appPermissions.pimPortal.permissions.view,
        appPermissions.pimPortal.name,
      ) && <Route path={rootPath} component={Home} />}
    </Switch>
  );
};

export default Pim;
